import React from 'react';

import { getAuthUser } from '../../../lib/services/auth.service';
import { useIdleSignOutMinutes } from '../../../lib/services/user.service';
import { IdleSignOutMonitor } from './idle-sign-out-monitor.component';

// Mounted once in the staff tree. The server decides who is signed out when idle (Check-in and
// Scoring-only users) and for how long; everyone else gets null and no monitor.
export const IdleSignOut: React.FC = () => {
  const authUser = getAuthUser();
  const { userId, minutes } = useIdleSignOutMinutes({ skip: !authUser });

  if (!authUser || !userId || userId !== authUser._id || !minutes) return null;
  return <IdleSignOutMonitor key={userId} userId={userId} timeoutMs={minutes * 60 * 1000} />;
};
